import type { ReactNode } from 'react'

import { DragOverlayStyled } from './styles/DragOverlayStyled'
import { IconPointerDown } from '../../elements/Icon'

export interface IDragOverlayProps {
  content?: ReactNode
  hideIcon?: boolean
}

export const DragOverlay = ({
  content = 'Drop files here to upload',
  hideIcon = false,
}: IDragOverlayProps) => {
  return (
    <DragOverlayStyled>
      {!hideIcon && <IconPointerDown size={36} />}
      <>{content}</>
    </DragOverlayStyled>
  )
}
